import { render } from "./ClienteDashboard.vue?vue&type=template&id=588815b5&scoped=true"
import script from "./ClienteDashboard.vue?vue&type=script&lang=js"
export * from "./ClienteDashboard.vue?vue&type=script&lang=js"

import "./ClienteDashboard.vue?vue&type=style&index=0&id=588815b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588815b5"]])

export default __exports__